import React from "react";
import Testimonials from "./Testimonials";

const testimonials = [
  {
    quote:
      "The experience was just awesome. The investor was super helpful and I was able to present the seller with a cash offer, which they then accepted. The process couldn’t be any easier. I love Cloud CMA.",
    name: "Briar Warren"
  },
  {
    quote: "I love to connect investors with sellers this way",
    name: "Elyse Struckman"
  },
  {
    quote:
      "I really appreciate the service. I believe that it is great to have that service available when listing homes especially when the home needs work and you don’t need to wait for an offer.",
    name: "Edwina Trent"
  },
  {
    quote:
      "I think this is a great new tool and look forward to using it again.",
    name: "Kenneth Lago"
  },
  {
    quote:
      "The services works as advertised, the communication from the investor was great.",
    name: "Francisco Perpuly"
  }
];

function IBuyerTestimonials() {
  return (
    <Testimonials
      title="Agents ❤️ iBuyer Connect"
      testimonials={testimonials}
    />
  );
}

export default IBuyerTestimonials;
